
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import QuoteForm from './components/QuoteForm';

export default function QuotePage() {
  useEffect(() => {
    // Update page title and meta description for SEO
    document.title = 'Get a Quote - Bollard Installation Essex | Free Estimates';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Get a free quote for bollard installation in Essex. Upload photos, specify requirements, and receive professional estimates for telescopic, fold down, and electric bollards.');
    }

    // Add Schema.org JSON-LD for quote page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Get a Quote - Bollard Installation",
      "description": "Request a free quote for professional bollard installation services in Essex",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/quote`,
      "mainEntity": {
        "@type": "Service",
        "name": "Bollard Installation Quote",
        "provider": {
          "@type": "LocalBusiness",
          "name": "Bollard Installation Essex"
        }
      }
    });
    document.head.appendChild(script);

    return () => {
      // Cleanup: remove the script when component unmounts
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-16">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Get Your Free Bollard Installation Quote
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Upload photos of your driveway and provide details about your requirements. 
              We'll provide you with a comprehensive quote for your bollard installation project.
            </p>
          </div>
          
          <QuoteForm />
        </div>
      </main>
      <Footer />
    </div>
  );
}
